export const SET_IP_LISTS = 'SET_IP_LISTS';
export const SET_IP_DETAIL = 'SET_IP_DETAIL';
export const RESET_IP_DETAIL = 'RESET_IP_DETAIL';
export const SET_PAGINATION = 'SET_PAGINATION';



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/flow/actionType.js